const Style = {
    image: 'mr-6 w-16 object-center',
    h1: 'text-2xl font-bold',
    logoContainer: 'my-3',
    setupProject: 'max-h-[500px] overflow-y-auto',
}
  
export default Style;